module.exports = __webpack_public_path__ + "img/delete.cc855be6.svg";